import { BaseCampaignStep } from '../BaseCampaignStep';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignStepTitle } from '../../common';
import { useCampaignsActions } from '../../../context';
import { DestinationSection } from './DestinationSection/DestinationSection';
import { useFormContext, useWatch } from 'react-hook-form';
import { CreateCampaignFormInput, CreateCampaignFormOutput } from '../../../validation';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetDistributionChannelConnectorsQuery } from '@/services/endpoints/distributionChannels';
import { DestinationCounter } from './DestinationSection/DestinationCounter';
import { Button } from '@/lib';

export const DestinationStep: FC = () => {
  const { t } = useTranslation('ALL');
  const { setNextStep } = useCampaignsActions();

  const { id: workspaceId } = useWorkspace();
  const { data } = useGetDistributionChannelConnectorsQuery({ workspaceId });

  const activeDestinations = useMemo(() => data?.filter((c) => c.authenticated && c.installed), [data]);

  const { control } = useFormContext<CreateCampaignFormInput, unknown, CreateCampaignFormOutput>();

  const dataDestinations = useWatch({
    control,
    name: 'connectors',
  });

  return (
    <BaseCampaignStep>
      <div className='flex items-start justify-between'>
        <CampaignStepTitle classNames={{ wrapper: 'max-w-[40%] mb-6' }} title='chooseDestination_title' description='chooseDestination_description' />
        <div className='flex flex-col items-end'>
          <Button className='inline-flex justify-center w-full max-w-[211px]' onClick={setNextStep} disabled={dataDestinations.length === 0}>
            {t('confirmDestinations')}
          </Button>
          <div className='flex mt-6'>
            <DestinationCounter className='bg-brand-600' label={t('selectedDestinations')} value={`${dataDestinations?.length}`}></DestinationCounter>
            <DestinationCounter className='bg-success-400' label={t('activeDestinations')} value={`${activeDestinations?.length || 0}`}></DestinationCounter>
          </div>
        </div>
      </div>
      <DestinationSection />
    </BaseCampaignStep>
  );
};
